import "styles/floatInput.less";

import { Dispatch, SetStateAction, useState } from "react";

import { DatePicker, DatePickerProps } from "antd";
import checkMark from "assets/images/checkmark.svg";
import warning from "assets/images/warning.svg";
import { EnableValidationT } from "components/basic/SignUpForm/SignUpForm";
import { format } from "date-fns";
import dayjs, { Dayjs } from "dayjs";

import SuffixIcon from "../Suffix/Suffix";

/* eslint-disable */
enum DatePickerMode {
    DECADE = "decade",
    YEAR = "year",
    MONTH = "month",
    DATE = "date",
}
/* eslint-enable */

interface FloatDatePickerProps {
    placeholder?: string;
    value?: string;
    maxDate: string;
    error?: string;
    onChange: (_date: string) => void;
    setEnableValidation?: Dispatch<SetStateAction<EnableValidationT>>;
    suffix?: string;
}

const FloatDatePicker = ({
    placeholder,
    value,
    maxDate,
    error,
    onChange,
    suffix,
}: FloatDatePickerProps) => {
    const [open, setOpen] = useState(false);
    const [mode, setMode] = useState<DatePickerMode>(DatePickerMode.DECADE);

    const handleChange: DatePickerProps["onChange"] = date => {
        if (date) {
            console.log("Selected date:", format(date.toDate(), "yyyy/MM/dd"));
            onChange(format(date.toDate(), "yyyy/MM/dd"));
            setOpen(false);
            // setMode(DatePickerMode.DECADE);
        }
    };

    const handlePanelChange = (_value: Dayjs, newMode: any) => {
        setMode(newMode);
    };

    const status = error ? "error" : "";

    return (
        <DatePicker
            className="w100"
            size="large"
            status={status}
            open={open}
            onOpenChange={setOpen}
            mode={mode}
            onPanelChange={handlePanelChange}
            onChange={handleChange}
            disabledDate={current => {
                const maxDateObj = dayjs(maxDate, "YYYY/MM/DD");
                return current && current.isAfter(maxDateObj);
            }}
            value={value ? dayjs(value, "YYYY/MM/DD") : null}
            placeholder={placeholder}
            suffixIcon={
                <SuffixIcon
                    hasError={!!error}
                    hasValue={!!value}
                    suffixSrc={suffix}
                    checkmarkSrc={checkMark}
                    warningSrc={warning}
                />
            }
        />
    );
};

export default FloatDatePicker;
